import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {startTour} from '../../../../app/modules/tutorial/startTour'
import {useReopenOnboarding} from '../../../../app/modules/onboarding/hooks/useOnboardingProgress'

/* eslint-disable jsx-a11y/anchor-is-valid */
type Props = {
  menuTrigger?: string
}

const Helper = ({menuTrigger = "{default: 'click', lg: 'hover'}"}: Props) => {
  const intl = useIntl()
  const reopenOnboarding = useReopenOnboarding()
  return (
    <>
      {/* begin::Menu toggle */}
      <a
        href='#'
        className={clsx('btn btn-icon btn-custom')}
        data-kt-menu-trigger={menuTrigger}
        data-kt-menu-attach='parent'
        data-kt-menu-placement='bottom-end'
      >
        <i className='bi bi-question-circle fs-3'></i>
      </a>
      {/* begin::Menu toggle */}

      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-icon-muted menu-active-bg menu-state-primary dash-menu-hover-green fw-semibold py-4 fs-6 w-275px'
        data-kt-menu='true'
      >
        {/* Cada opção no seu próprio `menu-item`: com as três dentro do mesmo item, o hover do item
            pintava todas as opções ao mesmo tempo. */}
        <div className='menu-item px-5'>
          <a
            href='#'
            className='menu-link px-5'
            onClick={(event) => {
              event.preventDefault()
              reopenOnboarding()
            }}
          >
            <span className='menu-icon' data-kt-element='icon'>
              <i className='bi bi-list-check'></i>
            </span>
            <span className='menu-title'>{intl.formatMessage({id: 'MENU.FIRST_STEPS'})}</span>
          </a>
        </div>
        <div className='menu-item px-5'>
          <a
            href='#'
            className='menu-link px-5'
            onClick={(event) => {
              event.preventDefault()
              startTour()
            }}
          >
            <span className='menu-icon' data-kt-element='icon'>
              <i className='bi bi-compass'></i>
            </span>
            <span className='menu-title'>{intl.formatMessage({id: 'MENU.RE_DO_TOUR'})}</span>
          </a>
        </div>
        <div className='menu-item px-5'>
          <a
            href='https://help.taskrush.com.br/'
            target='_blank'
            rel='noreferrer'
            className='menu-link px-5'
          >
            <span className='menu-icon' data-kt-element='icon'>
              <i className='bi bi-info-circle'></i>
            </span>
            <span className='menu-title'>{intl.formatMessage({id: 'MENU.HELP'})}</span>
          </a>
        </div>
      </div>
      {/* end::Menu */}
    </>
  )
}

export {Helper}
